import type React from 'react';

import type { FieldValidator } from 'final-form';
import { Field } from 'react-final-form';

import { Label } from '#src/app/shared/components/adminShadcn';
import { RichTextEditor } from '#src/app/shared/components/richTextEditor';

import { useRichTextEditorConfig } from './hooks/useRichTextEditorConfig';

export const EditorField: React.FC<{
	fieldName: string;
	label: string;
	isBlurb?: boolean;
	initialValue?: string;
	rteConfig?: Record<string, unknown>;
	validate?: FieldValidator<string | undefined>;
}> = ({ fieldName, label, isBlurb = false, initialValue, rteConfig, validate }) => {
	const {
		data: { editorConfig },
	} = useRichTextEditorConfig({ isBlurb, rteConfig });

	return (
		<div className="admin:mt-4">
			<Field<string | undefined> name={fieldName} validate={validate}>
				{({ input: { onChange }, meta }) => (
					<div className="admin:flex admin:flex-col">
						<Label htmlFor={fieldName}>{label}</Label>
						<RichTextEditor
							textEditorId={fieldName}
							initialValue={initialValue || ''}
							onEditorChange={onChange}
							ariaLabel="Text Editor"
							descriptiveLabel="Description"
							hideLabel
							customEditorConfig={editorConfig}
						/>
						{meta.touched && meta.error && (
							<p role="alert" className="admin:mt-1 admin:text-xs admin:text-destructive">
								{meta.error}
							</p>
						)}
					</div>
				)}
			</Field>
		</div>
	);
};
